import { withNamespace } from 'shared/lib';
import { CommonCenterModal } from 'shared/ui';

import { useAllCheckBtn, useBindEvent, useControlNonBenefit, useCreateFileInfo } from '../model';

import { useModal } from './ModalProvider';
import { SignModalContainer } from './SignModalContainer';
import './temp.css';

export const MobileForm = ({ children }) => {
  return children;
};

const TemplateContainer = ({ html: __html }) => {
  const { toggles, setAllToggle } = useBindEvent();
  useAllCheckBtn({ toggles, setAllToggle });
  useControlNonBenefit();
  useCreateFileInfo();

  return <div dangerouslySetInnerHTML={{ __html }}></div>;
};

const Modal = () => {
  const { signModal, guideModal, resetGuideModal } = useModal();

  if (signModal.open) return <SignModalContainer />;
  if (guideModal.open)
    return (
      <CommonCenterModal
        show={guideModal.open}
        title={guideModal.title}
        subTitle={guideModal.subTitle}
        btnText={'확인'}
        handleClose={() => {
          guideModal.callback();
          resetGuideModal();
        }}
      />
    );
};

export default withNamespace(MobileForm, {
  TemplateContainer,
  Modal,
});
